import { render, staticRenderFns } from "./setRole.vue?vue&type=template&id=4b28ac96"
import script from "./setRole.vue?vue&type=script&lang=js"
export * from "./setRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports